import type { ReactNode } from 'react';
import useAsync from 'react-use/esm/useAsync';
import { useAdAmsApi } from '../api/useAdAmsApi';

/**
 * Asks the plugin's backend, not the permission policy: VIEWER is everyone's
 * default role, so only the backend knows which viewers are key users.
 */
export const useAdAmsAccess = () => {
  const api = useAdAmsApi();
  const me = useAsync(() => api.me(), [api]);
  return { loading: me.loading, allowed: Boolean(me.value?.canAccess) };
};

export const AdAmsNavGate = ({ children }: { children: ReactNode }) => {
  const { loading, allowed } = useAdAmsAccess();

  if (loading || !allowed) {
    return null;
  }

  return <>{children}</>;
};
